import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { View } from 'react-native'
import { CheckboxItemProps } from 'react-native-paper'
import { StyleSheet } from 'react-native-unistyles'

import Skeleton from '@/components/shared/Skeleton'
import UniCheckboxItem from '@/components/unistyles/UniCheckboxItem'

interface Props<C extends FieldValues> {
  fieldName: Path<C>
  required: boolean
  control: Control<C, any>
  isLoading?: boolean
  onBlur?: () => void
}

const FormFieldCheckbox = <C extends FieldValues>({
  fieldName,
  required,
  control,
  isLoading,
  style,
  onBlur,
  ...props
}: Props<C> & CheckboxItemProps) => {
  return (
    <View style={[style, styles.root]}>
      <Skeleton isLoading={isLoading}>
        <Controller
          control={control}
          name={fieldName}
          render={({ field: { onChange, onBlur: formOnBlur, value } }) => (
            <View {...props}>
              <UniCheckboxItem
                mode="android"
                position="leading"
                {...props}
                labelStyle={styles.label}
                onPress={() => {
                  onChange(!value)
                  formOnBlur()
                  onBlur?.()
                }}
                status={value ? 'checked' : 'unchecked'}
                style={styles.container}
                testID={`${fieldName}-checkboxInput`}
              />
            </View>
          )}
          rules={{
            required: required,
          }}
        />
      </Skeleton>
    </View>
  )
}

export default FormFieldCheckbox

const styles = StyleSheet.create(() => ({
  container: {
    marginLeft: -8,
  },
  label: {
    paddingLeft: 4,
    textAlign: 'left',
  },
  root: {
    marginTop: 5,
    // justifyContent: 'center',
    minHeight: 54,
  },
}))
